import React, {useEffect, useState} from 'react';
import analytics from '@react-native-firebase/analytics';

import {Container, Content, LimiteItem, LimitesContainer} from './styles';
import {Header} from '../../components/Interface/Headers/Header';
import {Titles} from '../../components/Interface/Typographies/Titles';
import {api} from '../../services/api';
import {useIsFocused} from '@react-navigation/native';
import {ProgressBar} from '../../components/Interface/Forms/ProgressBar';

export function Limites() {
  const isFocused = useIsFocused();

  const [qtdLimiteLitros, setQtdLimiteLitros] = useState(0);
  const [qtdLitrosCliente, setQtdLitrosCliente] = useState(0);

  const [qtdLimiteComprasDia, setQtdLimiteComprasDia] = useState(0);
  const [qtdComprasDiaCliente, setQtdComprasDiaCliente] = useState(0);

  const [qtdLimiteComprasSemana, setQtdLimiteComprasSemana] = useState(0);
  const [qtdComprasSemanaCliente, setQtdComprasSemanaCliente] = useState(0);

  const [qtdLimiteCartoes, setQtdLimiteCartoes] = useState(0);
  const [qtdCartoesClientes, setQtdCartoesClientes] = useState(0);

  useEffect(() => {
    analytics().logEvent('tela_limites_cartao');
  }, []);

  useEffect(() => {
    let isMounted = true;
    async function fetchLimites() {
      await api
        .get('/consultaLimites')
        .then(({data}) => {
          if (data) {
            if (isMounted) {
              if (data.QTD_LIMITE_LITROS) {
                setQtdLimiteLitros(data.QTD_LIMITE_LITROS);
              }
              if (data.QTD_LITROS_CLIENTE) {
                setQtdLitrosCliente(data.QTD_LITROS_CLIENTE);
              }

              if (data.QTD_LIMITE_COMPRAS_DIA) {
                setQtdLimiteComprasDia(data.QTD_LIMITE_COMPRAS_DIA);
              }

              if (data.QTD_COMPRAS_DIA_CLIENTE) {
                setQtdComprasDiaCliente(data.QTD_COMPRAS_DIA_CLIENTE);
              }

              if (data.QTD_LIMITE_COMPRAS_SEMANA) {
                setQtdLimiteComprasSemana(data.QTD_LIMITE_COMPRAS_SEMANA);
              }

              if (data.QTD_COMPRAS_SEMANA_CLIENTE) {
                setQtdComprasSemanaCliente(data.QTD_COMPRAS_SEMANA_CLIENTE);
              }

              if (data.QTD_LIMITE_CARTOES) {
                setQtdLimiteCartoes(data.QTD_LIMITE_CARTOES);
              }

              if (data.QTD_CARTOES_CLIENTE) {
                setQtdCartoesClientes(data.QTD_CARTOES_CLIENTE);
              }

              isMounted = false;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    }

    fetchLimites();

    return () => {
      isMounted = false;
    };
  }, [isFocused]);
  return (
    <Container>
      <Header icon="chevron-left" />

      <Content>
        <Titles
          title="Meus limites"
          subtitle="Confira abaixo todos os seus limites de compra e uso:"
        />

        <LimitesContainer>
          <LimiteItem>
            <ProgressBar
              maxPercentage={qtdLimiteLitros}
              percentage={qtdLitrosCliente}
              title="Litros disponíveis:"
              suffix="lts"
            />
          </LimiteItem>
          <LimiteItem>
            <ProgressBar
              maxPercentage={qtdLimiteComprasDia}
              percentage={qtdComprasDiaCliente}
              title="Compras disponíveis por dia:"
            />
          </LimiteItem>
          <LimiteItem>
            <ProgressBar
              maxPercentage={qtdLimiteComprasSemana}
              percentage={qtdComprasSemanaCliente}
              title="Compras disponíveis por semana:"
            />
          </LimiteItem>
          <LimiteItem>
            <ProgressBar
              maxPercentage={qtdLimiteCartoes}
              percentage={qtdCartoesClientes}
              title="Cartões que podem ser usados:"
            />
          </LimiteItem>
        </LimitesContainer>
      </Content>
    </Container>
  );
}
